module.exports = __webpack_public_path__ + "assets/img/gar5-2.8d73e3fe.jpg";